import { render, staticRenderFns } from "./ColorPickerView.vue?vue&type=template&id=607f30a8&"
import script from "./ColorPickerView.vue?vue&type=script&lang=js&"
export * from "./ColorPickerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports